import { Info } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from 'src/components/ui/tooltip';
import { cn } from 'src/lib/utils';

type ForecastPaginatedProductDetailsLineProps = {
  label: string;
  value: string;
  fullWidth: boolean;
  tooltip?: string;
};

export const ForecastPaginatedProductDetailsLine = ({
  label,
  value,
  fullWidth,
  tooltip,
}: ForecastPaginatedProductDetailsLineProps) => {
  return (
    <div className='flex flex-row gap-x-2'>
      <span className='text-nowrap text-layout-foreground-secondary'>
        {label} :
      </span>
      {tooltip ? (
        <Tooltip>
          <TooltipTrigger className='flex flex-row items-center outline-hidden'>
            <span
              className={cn(
                'max-w-72 truncate md:max-w-80 lg:max-w-64',
                fullWidth && 'max-w-72 md:max-w-80 lg:max-w-[32rem]',
              )}
            >
              {value}
            </span>
            <Info
              className='mt-0.5 ml-1 h-3 w-3 text-layout-foreground-secondary'
              strokeWidth={2}
            />
          </TooltipTrigger>
          <TooltipContent>{tooltip}</TooltipContent>
        </Tooltip>
      ) : (
        <span
          className={cn(
            'max-w-72 truncate md:max-w-80 lg:max-w-64',
            fullWidth && 'max-w-72 md:max-w-80 lg:max-w-[32rem]',
          )}
        >
          {value}
        </span>
      )}
    </div>
  );
};
